import {CanActivateChildFn, CanActivateFn, Router} from "@angular/router";
import {inject} from "@angular/core";
import {of, switchMap} from "rxjs";
import {AuthService} from "../auth.service";
export const NoAuthGuard: CanActivateFn | CanActivateChildFn = () => {
  const router: Router = inject(Router);

  // Check the authentication status
  return inject(AuthService).check().pipe(
    switchMap((authenticated) => {
      // If the user is authenticated...
      if (authenticated) {
        router.navigateByUrl('/manage-portals').then();
        return of(true);
      }
      // Allow the access
      return of(true);
    }),
  );
};
